import React, { FC, ReactElement } from "react";
import { useUserService } from "../../../services/userService";
import { Navigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";

interface WithAdminAccessProps {
  children: ReactElement;
}

export const WithAdminAccess: FC<WithAdminAccessProps> = ({ children }) => {
  const { user, loading: userLoading } = useUserService();

  if (userLoading) {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <Spinner animation="border" role="status"></Spinner>
      </div>
    );
  }

  if (!user?.admin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
